export const baseUrlSG = "https://spritualapi.encouragingwordapp.com/api/v1/"
export const baseUrlEW = "https://encourageapi.encouragingwordapp.com/api/v1/"